import { render, staticRenderFns } from "./AutomatorControls.vue?vue&type=template&id=3a688f90&scoped=true"
import script from "./AutomatorControls.vue?vue&type=script&lang=js"
export * from "./AutomatorControls.vue?vue&type=script&lang=js"
import style0 from "./AutomatorControls.vue?vue&type=style&index=0&id=3a688f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a688f90",
  null
  
)

export default component.exports